var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29825 5.70175L18.2982 19.7018C18.4737 19.8947 18.7193 20 19 20C19.5439 20 20 19.5439 20 19C20 18.7193 19.8947 18.4737 19.7018 18.2982L5.70175 4.29824C5.52632 4.10526 5.2807 4 5 4C4.45614 4 4 4.45614 4 5C4 5.2807 4.10526 5.52632 4.29825 5.70175ZM18.2982 4.29824L4.29825 18.2982C4.10526 18.4737 4 18.7193 4 19C4 19.5439 4.45614 20 5 20C5.2807 20 5.52632 19.8947 5.70175 19.7018L19.7018 5.70175C19.8947 5.52632 20 5.2807 20 5C20 4.45614 19.5439 4 19 4C18.7193 4 18.4737 4.10526 18.2982 4.29824Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOutlined);
export default __webpack_public_path__ + "static/media/close_outlined.5a278286.svg";
export { ForwardRef as ReactComponent };